import { v4 as uuidv4 } from 'uuid';

declare global {
  interface Window {
    onNativePermissionResult: (status: string) => void;
  }
}

const HelperService = () => {

    // const alertHelper = (
    //     title: string, 
    //     body: string, 
    //     textFirst: string, 
    //     styleFirst: 'default' | 'cancel' | 'destructive' = 'cancel', 
    //     textSecond: string, 
    //     styleSecond: 'default' | 'cancel' | 'destructive' = 'destructive', 
    //     onPressFunction: () => void) => {
    //         Alert.alert(title, body, [
    //             {
    //                 text: textFirst,
    //                 style: styleFirst,
    //             },
    //             {
    //                 text: textSecond,
    //                 style: styleSecond,
    //                 onPress: onPressFunction,
    //             },
    //         ]
    //     );
    // }

    const truncate = (str: string | undefined, maxlength: number) => {
        if (str) {
        return (str.length > maxlength) ?
        str.slice(0, maxlength - 1) + '…' : str;
        } else {
        return str;
        }
    };

    const generateCustomId = (name: string) => {
        const prefix = name;
        const uniquePart = uuidv4();
        return `${prefix}-${uniquePart}`;
    };

    function isSafari() {
        const userAgent = navigator.userAgent;

        // Safari (sur macOS et iOS) inclut "Safari" et N'inclut PAS "Chrome" ou "Chromium" ou "Edg" (Edge)
        // car Chrome/Edge/Firefox ont aussi "Safari" dans leur User-Agent historique.
        // De plus, il doit inclure 'AppleWebKit'.
        return userAgent.includes('Safari') &&
                !userAgent.includes('Chrome') &&
                !userAgent.includes('Chromium') &&
                !userAgent.includes('Edg') && // Pour Microsoft Edge
                !userAgent.includes('Firefox') &&
                userAgent.includes('AppleWebKit'); // Safari utilise WebKit
    }

    function isIOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform) ||
        // Pour les iPads modernes qui se font passer pour des Mac
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }

    function isSafariOnIOS() {
        return isIOS() && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('CriOS') && !navigator.userAgent.includes('FxiOS');
        // CriOS = Chrome sur iOS, FxiOS = Firefox sur iOS.
    }

    const requestNotificationPermission = async () => {
        if (!('Notification' in window)) {
            alert('Votre navigateur ne supporte pas les notifications.');
            return;
        }

        try {
            const permission = await Notification.requestPermission();
            // setPermissionStatus(permission);

            if (permission === 'granted') {
                console.log('Permission de notification accordée !');
                // Ici, vous pouvez afficher une notification de test si vous le souhaitez
                // new Notification("Merci !", { body: "Vos notifications sont activées." });
            } else if (permission === 'denied') {
                console.warn('Permission de notification refusée par l\'utilisateur.');
                alert('Vous avez refusé les notifications. Vous pouvez les activer dans les paramètres de votre navigateur.');
            } else { // 'default' - l'utilisateur a ignoré ou la demande est toujours en attente (rare)
                console.log('L\'utilisateur a ignoré la demande de notification ou le statut est par défaut.');
            }
            return permission
        } catch (error) {
            console.error('Erreur lors de la demande de permission de notification :', error);
        // } finally {
            // Une fois la demande faite (accordée ou refusée), on peut cacher le bouton
            // à moins que vous ne vouliez le laisser pour retenter ou rediriger.
            // Pour ce simple exemple, on le cache.
            // if (permissionStatus !== 'default') {
            //      setShowButton(false);
            // }
        }
    };

    return {
        // alertHelper, 
        truncate, generateCustomId, isSafari, isIOS, isSafariOnIOS, requestNotificationPermission
    };
  };
  
  export default HelperService;